import React from 'react';
import { Alert } from '@trellixio/roaster-coffee';
import PropTypes from 'prop-types';

const AuthorizationAlert = ({ condition = false, level = null, message = null }) => {
  return condition && <Alert level={level} message={<span className="alert-children">{message}</span>} />;
};

AuthorizationAlert.propTypes = {
  condition: PropTypes.bool,
  level: PropTypes.string,
  message: PropTypes.string,
};

export default AuthorizationAlert;
